import React from 'react';
import { RadioCheck, Input } from './RadioButton.style';
import { isChecked } from './util.js';

const RadioButton = (props) => {
  const { checkbox, setCheckedValue, onChange, id, type, name, checked, className, onClick, field } = props;
  return (
    <RadioCheck
      onClick={() => {
        setCheckedValue(id);
        onClick && onClick();
      }}
    >
      <Input
        type={type || 'checkbox'}
        name={name || 'check'}
        id={id}
        checked={isChecked(checkbox, id, checked, field)}
        onChange={onChange}
        onClick={(e) => {
          e.stopPropagation();
          setCheckedValue(id);
          onClick && onClick();
        }}
        className={className}
      />
    </RadioCheck>
  );
};

RadioButton.defaultProps = {
  setCheckedValue: () => {},
  onChange: () => {},
};

export default RadioButton;
